var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9621 27.7807H8.90332V10.1336C8.90332 8.96611 9.85344 8.01599 11.021 8.01599H37.8445C39.012 8.01599 39.9621 8.96611 39.9621 10.1336V27.7807ZM10.3151 26.3689H38.5504V10.1336C38.5504 9.7447 38.2341 9.42776 37.8445 9.42776H11.021C10.632 9.42776 10.3151 9.7447 10.3151 10.1336V26.3689Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0791 39.0748H6.7857C6.10664 39.0748 5.48546 38.7614 5.0824 38.215C4.67934 37.6687 4.56217 36.9833 4.76193 36.3346L4.79087 36.2576L9.14899 26.3689H39.7172L44.1043 36.3346C44.3033 36.9833 44.1869 37.6694 43.7831 38.215C43.3793 38.7621 42.7582 39.0748 42.0791 39.0748ZM6.1024 36.7828C6.04946 36.9889 6.09111 37.2042 6.21887 37.3765C6.35299 37.5593 6.55981 37.663 6.7857 37.663H42.0791C42.3057 37.663 42.5125 37.5586 42.6473 37.3765C42.7751 37.2042 42.8168 36.9889 42.7638 36.7828L38.7961 27.7807H10.0695L6.1024 36.7828Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4329 30.6042H12.4329C12.0433 30.6042 11.7271 30.2887 11.7271 29.8983C11.7271 29.508 12.0433 29.1924 12.4329 29.1924H36.4329C36.8233 29.1924 37.1388 29.508 37.1388 29.8983C37.1388 30.2887 36.8233 30.6042 36.4329 30.6042Z",
    fill: "#DC0032"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8443 33.4278H11.0208C10.6312 33.4278 10.3149 33.1122 10.3149 32.7219C10.3149 32.3315 10.6312 32.016 11.0208 32.016H37.8443C38.2347 32.016 38.5502 32.3315 38.5502 32.7219C38.5502 33.1122 38.2347 33.4278 37.8443 33.4278Z",
    fill: "#DC0032"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6682 36.2513H20.1976C19.8079 36.2513 19.4917 35.9357 19.4917 35.5454C19.4917 35.155 19.8079 34.8395 20.1976 34.8395H28.6682C29.0585 34.8395 29.3741 35.155 29.3741 35.5454C29.3741 35.9357 29.0585 36.2513 28.6682 36.2513Z",
    fill: "#DC0032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.d4572302eeb5168783205cab370929b3.svg";
export { ForwardRef as ReactComponent };